export default class urlValidator {
    constructor() {
    }

    validate(value) {
        return !!(value.match(/^((http:\/\/)|(https:\/\/))?(www\.)?[a-zA-Z0-9-]{2,52}\.[a-zA-Z]{2,12}/));
    }
}
